import * as React from "react";
import styles from "./page2.module.scss";
import globe from "../../gifs/globe.gif";
import tick from "../../images/greengif.gif";
import chart from "../../images/graphgif.gif";
import sequence from "../../images/candlegif.gif";

export default function Page2() {
  return (
    <div className={styles.mainwrapper}>
      <div>
        <p className={styles.connect}>Build with Connect</p>
      </div>
      <div className={styles.mainbox}>
        <div className={styles.first}>
          <div className={styles.imagecontainer}>
            <img
              className={styles.firstimage}
              src={globe}
              alt="globe"
              style={{ width: "75px", height: "75px" }}
            />
          </div>
          <div>
            <p className={styles.firstheading}>Web Sockets</p>
          </div>
          <div>
            <p className={styles.firstpara}>
              The WebSocket API enables two-way communication between a browser
              and server.
            </p>
          </div>
        </div>
        <div className={styles.second}>
          <div
            className={styles.imagecontainer}
            style={{ background: "#C8FCC8" }}
          >
            <img
              className={styles.firstimage}
              src={tick}
              alt="tickgif"
              style={{ width: "75px", height: "75px" }}
            />
          </div>
          <div>
            <p className={styles.firstheading}>Place order</p>
          </div>
          <div>
            <p className={styles.firstpara}>
              When your order matches in the stock market, the trade executes;
              orders are often placed online or by phone.
            </p>
          </div>
        </div>
        <div className={styles.third}>
          <div
            className={styles.imagecontainer}
            style={{ background: "#BAE3EF" }}
          >
            <img
              className={styles.firstimage}
              src={chart}
              alt="chartgif"
              style={{ width: "75px", height: "75px" }}
            />
          </div>
          <div>
            <p className={styles.firstheading}>Portfolio</p>
          </div>
          <div>
            <p className={styles.firstpara}>
              A portfolio contains financial assets like stocks, bonds, and
              cash, which are often considered its core components.
            </p>
          </div>
        </div>
        <div className={styles.fourth}>
          <div
            className={styles.imagecontainer}
            style={{ background: "#F7C35D" }}
          >
            <img
              className={styles.firstimage}
              src={sequence}
              alt="sequencegif"
              style={{ width: "75px", height: "75px" }}
            />
          </div>
          <div>
            <p className={styles.firstheading}>Historical Data</p>
          </div>
          <div>
            <p className={styles.firstpara}>
              A portfolio consists of assets like stocks, bonds, and cash,
              commonly seen as its central components.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
